import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import UtilMethods from "../../util/UtilMethods";
import { sendEmail } from "../../services/EmailSender";
import { updateSubscriptions     } from "../../services/AdminServices";

const regions = [
  "Americas",
  "Sweden",
  "Europe",
  "United Kingdom",
  "Africa",
  "Middle East",
  "Kerala",
  "India (excluding Kerala)",
];

export default function SubscriptionForm() {
  const { t, i18n } = useTranslation("labels");

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [selectedRegions, setSelectedRegions] = useState(regions);
  const [status, setStatus] = useState(null);

  const isAllSelected = selectedRegions.length === regions.length;

  const handleSubmit = async (e) => {
        const subscriptions = {
      name,
      phone,
      email,
      regions: selectedRegions,
      lang: i18n.language,
      createdAt: new Date().toISOString(),
      status: "active",
    };
    console.log("Submitting subscription form",subscriptions);

    e.preventDefault();

    if (!UtilMethods.validateEmail(email)) {
      setStatus("error");
      return;
    }


try {
      await updateSubscriptions(subscriptions);
      subscriptions.unSubscribeURL=`${process.env.REACT_APP_URL}/unsubscribe/${encodeURIComponent(email)}`;
      sendEmail(subscriptions);
      console.log("Subscription form updated successfully");
    } catch (error) {
      console.error("Error updating subscription form", error);
      setStatus("error");
      return;
    }

    setStatus("success");
    setName("");
    setPhone("");
    setEmail("");
  };

  return (
    <section className="mrc-wrapper">
      <div className="mrc-left">
        <h1>{t("subscription.title")}</h1>
        <p>{t("subscription.subtitle")}</p>
      </div>

      <form className="mrc-form" onSubmit={handleSubmit}>
        <input
          placeholder={t("subscription.name")}
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />

        <input
          placeholder={t("subscription.phone")}
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />

        <input
          placeholder={t("subscription.email")}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <div className="region-box">
          <span>{t("subscription.region")}</span>

          <div className="region-options">
            <label>
              <input
                type="checkbox"
                checked={isAllSelected}
                onChange={(e) =>
                  setSelectedRegions(e.target.checked ? regions : [])
                }
              />
              {t("subscription.all")}
            </label>

            {regions.map((r) => (
              <label key={r}>
                <input
                  type="checkbox"
                  checked={selectedRegions.includes(r)}
                  onChange={(e) =>
                    setSelectedRegions((s) =>
                      e.target.checked
                        ? [...s, r]
                        : s.filter((x) => x !== r)
                    )
                  }
                />
                {r}
              </label>
            ))}
          </div>
        </div>

        {/* Language switcher */}
        <select
          value={i18n.language}
          onChange={(e) => i18n.changeLanguage(e.target.value)}
        >
          <option value="en">English</option>
          <option value="es">Español</option>
        </select>

        <button type="submit">
          {t("subscription.send")}
        </button>

        {status === "success" && (
          <p className="success">{t("subscription.success")}</p>
        )}
        {status === "error" && (
          <p className="error">{t("subscription.error")}</p>
        )}
      </form>
    </section>
  );
}
